import { DetailPage } from '../../components/DetailPage/DetailPage';

import { BlockedNumbersSection } from './components/BlockedNumbersSection/BlockedNumbersSection';

import { PageContainer } from '@components/PageContainer/PageContainer';

export function CallsBlockedNumbersPage() {
  return (
    <PageContainer>
      <DetailPage data-test='calls-blocked-numbers-page'>
        <BlockedNumbersSection />
      </DetailPage>
    </PageContainer>
  );
}
